import { useMutation } from '@tanstack/react-query';

import { hasKey } from '~/utils';
import { config } from '~/config';
import { useRequest } from '~/lib/useRequest';
import {
  GetRejectionLetterPreviewResponse,
  GetRejectionLetterPreviewRequestBody,
} from '@ab/ams-school-api/types/private/v1';

export type RejectionLetterPreview = GetRejectionLetterPreviewResponse['data']['attributes'];

type GetRejectionLetterPreviewRequestPayload = Omit<GetRejectionLetterPreviewRequestBody['data']['attributes'], 'type'>;

export function useRejectionLetterPreview(applicationId: string) {
  const request = useRequest();
  const { isLoading, error, mutateAsync } = useMutation(
    ['application_pre_offer_letter_preview', applicationId],
    async (payload: GetRejectionLetterPreviewRequestPayload) => {
      const response = await request<GetRejectionLetterPreviewResponse>(
        `${config.apiHost}/private/v1/applications/${applicationId}/rejection_letter_preview`,
        {
          method: 'POST',
          body: {
            data: {
              type: 'letter_preview',
              attributes: { ...payload, type: 'REJECTION' },
            },
          } as GetRejectionLetterPreviewRequestBody,
          isExpectedResponse,
        }
      );

      const attributes = response.data.attributes;
      return {
        ...attributes,
      };
    }
  );
  return {
    generateRejectionLetterPreview: mutateAsync,
    isGeneratingLetterPreview: isLoading,
    letterPreviewGenerationError: error,
  };
}

function isExpectedResponse(res: unknown): res is GetRejectionLetterPreviewResponse {
  return Boolean(res && typeof res === 'object' && hasKey('data', res));
}
